module.exports = __webpack_public_path__ + "static/media/cloud.0f905087.svg";